import { Component, OnInit } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'app-icon-box',
  templateUrl: './icon-box.component.html',
  styleUrls: ['./icon-box.component.css']
})
export class IconBoxComponent implements OnInit {


  icon_box : any = [
                  {
                    title:"Address",
                    description:"<br/>1726 Farvagny, Switzerland",
                    icon_class:"la-map-marker",
                  },
                  {
                    title:"Email",
                    description:'<br/><a href="javascript:void(0);">bertrandpetit10@gmail.com</a>',
                    icon_class:"la-envelope-open",
                  },
                  {
                    title:"Phone",
                    description:"<br/>(+41) 79 402 88 04",
                    icon_class:"la-phone-volume",
                  },
            ];

  constructor() { }


  ngOnInit(): void {
  }

}
